module.exports = __webpack_public_path__ + "assets/assessment-active.7a362c49.svg";